import { ProcedureStepFieldValuesReviewService as OvermapProcedureStepFieldValuesReviewService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProcedureStepFieldValuesReviewService extends OvermapProcedureStepFieldValuesReviewService<
	RootState,
	AppSDK
> {
	host = import.meta.env.REACT_APP_API_URL
}
